export default {
  app: {
    name: 'APAC Status',
    search_placeholder: 'Rechercher comptes, utilisateurs, sondes…',
    search_palette_placeholder:
      'Rechercher comptes, utilisateurs, sondes, pages de statut, maintenance…',
    search_hint_min_chars: 'Saisissez au moins 2 caractères',
    search_loading: 'Recherche…',
    search_no_results: 'Aucun résultat',
    keyboard_hint: '⌘K',
    search: {
      sections: {
        account: 'Comptes',
        user: 'Utilisateurs',
        monitor: 'Sondes',
        status_page: 'Pages de statut',
        maintenance: 'Maintenance',
      },
    },
    actions: {
      sign_out: 'Se déconnecter',
      switch_account: 'Changer de compte',
      invite_user: 'Inviter un utilisateur',
      create_account: 'Créer un compte',
      save: 'Enregistrer',
      cancel: 'Annuler',
    },
    create_menu: {
      title: 'Créer',
      account: 'Créer un compte',
      user: 'Inviter un utilisateur',
      monitor: 'Nouvelle sonde',
      status_page: 'Nouvelle page de statut',
      maintenance: 'Nouvelle fenêtre de maintenance',
    },
  },
  nav: {
    dashboard: 'Accueil',
    monitors: 'Sondes',
    incidents: 'Incidents',
    maintenance: 'Fenêtres de maintenance',
    status_pages: 'Pages de statut',
    reports: 'Rapports',
    audit_log: 'Journal d’audit',
    settings: 'Paramètres',
    admin_accounts: 'Tous les comptes',
    admin_users: 'Utilisateurs',
    admin_dashboard: "Vue d'ensemble",
    users: 'Utilisateurs',
  },
  admin_dashboard: {
    title: "Vue d'ensemble de la plateforme",
    subtitle: 'Santé agrégée sur tous les comptes.',
    metrics: {
      total_accounts: 'Comptes',
      total_monitors: 'Sondes',
      active_incidents: 'Incidents actifs',
      uptime_24h: 'Disponibilité (24 h)',
    },
    health: {
      title: 'État des sondes',
      operational: 'Opérationnel',
      degraded: 'Dégradé',
      down: 'Indisponible',
      paused: 'En pause',
      total: 'Total',
    },
    active_incidents: {
      title: 'Incidents actifs',
      empty_title: 'Aucun incident actif',
      empty_description: 'Toutes les sondes de tous les comptes sont saines.',
    },
    accounts: {
      title: 'Comptes',
    },
  },
  dashboard: {
    title: 'Accueil',
    subtitle: 'Vue d’ensemble des sondes et incidents du compte {account}.',
    actions: {
      view_status_page: 'Voir la page de statut',
      add_monitor: 'Ajouter une sonde',
      refresh: 'Actualiser',
    },
    metrics: {
      uptime_24h: 'Disponibilité (24 h)',
      avg_latency: 'Latence moyenne',
      active_incidents: 'Incidents actifs',
      mtbf_24h: 'MTBF (24 h)',
      over_n_monitors: 'sur {count}',
      incidents_24h: '{count} en 24 h',
    },
    health: {
      title: 'État des sondes',
      operational: 'Opérationnel',
      degraded: 'Dégradé',
      down: 'Indisponible',
      paused: 'En pause',
      total: 'Total',
    },
    recent_incidents: {
      title: 'Incidents récents',
      view_all: 'Tout voir',
      empty_title: 'Aucun incident récent',
      empty_description: 'Les incidents apparaîtront ici lorsque des sondes échoueront.',
    },
    recent_monitors: {
      title: 'Sondes',
      view_all: 'Tout voir',
      empty_title: 'Aucune sonde pour le moment',
      empty_description: 'Ajoutez une première sonde pour suivre la disponibilité.',
    },
  },
  auth: {
    sign_in: 'Connectez-vous à APAC Status',
    email: 'E-mail',
    password: 'Mot de passe',
    submit: 'Continuer',
    forgot_password: 'Mot de passe oublié ?',
    two_factor_title: 'Authentification à deux facteurs',
    two_factor_hint: "Entrez le code à 6 chiffres de votre application d'authentification.",
    forgot_password_title: 'Réinitialiser le mot de passe',
    forgot_password_hint: 'Saisissez votre e-mail pour recevoir un lien.',
    forgot_password_submit: 'Envoyer le lien',
    set_password_title: 'Définir votre mot de passe',
    set_password_hint: 'Choisissez un mot de passe pour finaliser votre compte.',
    new_password: 'Nouveau mot de passe',
    submit_set_password: 'Définir le mot de passe',
    no_signup: "L'inscription est désactivée — contactez votre administrateur.",
  },
  empty: {
    no_data: 'Aucune donnée pour le moment',
    no_data_hint: 'Cette vue est volontairement vide dans le squelette.',
  },
  errors: {
    generic: 'Une erreur est survenue.',
    unauthorized: 'Vous devez vous connecter.',
    forbidden: "Vous n'avez pas la permission requise.",
  },
};
